import { render, staticRenderFns } from "./staffs.vue?vue&type=template&id=1a4a43cc&scoped=true&"
import script from "./staffs.vue?vue&type=script&lang=js&"
export * from "./staffs.vue?vue&type=script&lang=js&"
import style0 from "./staffs.vue?vue&type=style&index=0&id=1a4a43cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4a43cc",
  null
  
)

export default component.exports